module.exports = __webpack_public_path__ + "a42a2587df26675f540990f343d460f0.pdf";